import React from "react";
import { FaAngleLeft } from "react-icons/fa";
import { New_ScrollX2025 } from "../../assets/icons";
import { useLocation, useNavigate } from "react-router-dom";

const SelectedPlanDetails = ({selectedPlan, couponDiscount}) => {
  // console.log('3 SelectedPlanDetails= ',selectedPlan);
  const navigate = useNavigate();
  const location = useLocation();
  // console.log(' SelectedPlanDetails ', location);
  const {isDashboard, projectId, isCard, pathSegments, isMoreInfo, isRender} = location.state || {};
  
  const navigateHandler = () => {

    // Dashboard => MoreInfo => Usr-Plans => Plan-Details
    if(isDashboard && isMoreInfo){ 
      navigate("/user-plans", { state: {isDashboard:isDashboard, isMoreInfo:isMoreInfo}});
    }
    
    // Scroll/Card Projecr => MoreInfo => Usr-Plans => Plan-Details
    else if(!isDashboard && isMoreInfo){ 
      navigate("/user-plans", { state: {isDashboard:isDashboard, isMoreInfo:true, isCard: isCard, projectId: projectId} });
    }
    

    // Render => MoreInfo => Usr-Plans => Plan-Details (Navbar Setting & MoreInfo Popup)    
    else if (isRender && isMoreInfo){
      navigate("/user-plans", { state: { isDashboard:isDashboard, isRender:true, isMoreInfo:true, isCard: isCard, projectId: projectId } });
    }
    
    // Render => Upgrade => Usr-Plans => Plan-Details (Export & Upgrade)
    else if (isRender && !isMoreInfo){
      navigate("/user-plans", { state: { isDashboard:isDashboard, isRender:true, isMoreInfo:false, isCard: isCard, projectId: projectId } });
    }
  }

  return (
    <>
      <div className="w-full bg-black flex flex-col items-center justify-center text-white">
        <div className=" w-[52%] flex flex-col gap-[1.2rem]">
          <section className="flex gap-2 items-center">
            <FaAngleLeft className="absolute left-[9rem] text-white text-xl cursor-pointer hover:text-gray-300 " onClick={navigateHandler}/>
            <img className="w-[35px] " src={New_ScrollX2025} />
            <h2 className="font-semibold text-[1.2rem]">ScrollX.io</h2>
          </section>

          <section className="flex flex-col items-start gap-[0.5rem]">
            <p className="text-gray-500 font-semibold text-[1rem]">Subscribe to {selectedPlan.type}</p>
            <div className="flex gap-[1rem]">
              <p className="text-4xl font-normal">{selectedPlan.currency} {selectedPlan.price}.00</p>{" "}
              <div className="text-[0.8rem] text-gray-500 flex flex-col justify-between">
                <p>per{" "}{selectedPlan.price === 99 ? "week" : selectedPlan.interval_validity}</p>
                <p>until cancelled</p>
              </div>
            </div>
          </section>

          <section className="w-full flex items-center justify-between border-b border-[#13141a] pb-[1rem]">
            <div className="flex flex-col gap-1">
              <p className="text-gray-300 text-[0.9rem] font-semibold">{selectedPlan.type}</p>
              <p className="text-gray-600 text-[0.7rem]">
                Billed{" "}{selectedPlan.interval_validity}{" "}until cancelled
              </p>
            </div>
             <div className="flex items-start text-[0.9rem] text-gray-300 font-normal">
              <p>{selectedPlan.currency}{selectedPlan.price}.00</p>
            </div>
          </section>

          <section className="w-full flex items-center justify-between border-b border-[#13141a] pb-[1rem]">
            <div className="flex flex-col gap-2">
              <p className="text-gray-300 text-[0.9rem] font-semibold ">Subtotal</p>
              <p className="text-gray-300 text-[0.9rem] font-semibold">Tax</p>
              {couponDiscount > 0 && (<p className="text-gray-300 text-[0.9rem] font-semibold">Discount</p>)}
            </div>

            <div className="flex flex-col gap-2 justify-between text-[0.9rem] text-gray-300 font-normal">
              <p>+ {selectedPlan.currency}{selectedPlan.price}.00</p>
              <p>+ {selectedPlan.currency}0.00</p>
              {couponDiscount > 0 && (
                <p className="text-gray-300 text-[0.9rem] font-semibold">- {selectedPlan.currency}{(selectedPlan.price * (couponDiscount / 100)).toFixed(2)}</p>
              )}
            </div>
          </section>

          <section className="w-full flex items-center justify-between pb-[1rem]">
            <div className="flex flex-col gap-2">
              <p className="text-gray-300 text-[0.9rem] font-semibold">Total due today</p>
            </div>
            <div className="flex flex-col gap-2 justify-between text-[0.9rem] text-gray-300 font-normal">
              <p>{selectedPlan.currency}{" "}
                {couponDiscount ? Math.abs(selectedPlan.price - (selectedPlan.price * (couponDiscount / 100)).toFixed(2)).toFixed(2) : Number(selectedPlan.price).toFixed(2)}
              </p>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default SelectedPlanDetails;
